import React from 'react'

const Footer = ({ footer }) => <p className="mt-5 text-center no-print">{footer}</p>

export default Footer
